export default __webpack_public_path__ + "static/media/acme-logo.99da86e4.png";